import React, { useEffect, useState, useContext } from "react";
import Module from "../../../../templates/components/Module";
import moment from "moment";
import Utilities from "../../../../../services/commonservice/utilities";
import Table2 from "../../../../templates/components/Table2";
import DatePicker from "../../../../templates/components/DatePicker";
import DimLoader from "../../../../templates/components/DimLoader";
import { store } from "../../../../../context/StateProvider";
import InvoiceService from "../../../../../services/api/invoice.service";
import PatientSelector from "../../../../templates/components/PatientSelector";
import HPTSelect from "../../../../templates/components/HPTSelect";
import { useGetLocationProviderServices } from "../../../../../services/cache/CacheService";
import CacheUtilities from "../../../../../services/cache/CacheUtilities";
import ReportService from "../../../../../services/api/report.service";

const EmployeeSalesReport = (props) => {
  // context state and dispatch 
  const globalStateAndDispatch = useContext(store)
  const state = globalStateAndDispatch.state
  const [employeeSalesReportList, setEmployeeSalesReportList] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("D"));
  const [endDate, setEndDate] = useState(moment().endOf("D"));
  const [initialMessage, setInitialMessage] = useState(true)
  const [isLocationClearable, setIsLocationClearable] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? false : true)
  const [locationId, setLocationId] = useState(state.practiceLocationId || null)
  const [doctorId, setDoctorId] = useState()
  const [providerList, setProviderList] = useState()
  const stateDoctorList = useGetLocationProviderServices();
  useEffect(async () => {
    if (locationId) {
      if (locationId == state.practiceLocationId) {
        setProviderList(stateDoctorList)
      }
      else {
        const locProviderServices = await CacheUtilities.pullServiceForLocationData(locationId);
        setProviderList(locProviderServices)
      }
    } else {
      const locProviderServices = await CacheUtilities.pullServiceForLocationData(null);
      setProviderList(locProviderServices)
    }
  }, [locationId, stateDoctorList]);

  const getEmployeeSalesReportLookup = () => {
    let reqObj = {};
    if (locationId) {
      reqObj.PracticeLocationId = locationId
    }
    if (startDate) reqObj.StartDate = moment(startDate).toISOString()
    if (endDate) reqObj.EndDate = moment(endDate).toISOString()

    if (doctorId) {
      reqObj.DoctorId = doctorId
    }
    setIsLoader(true)
    setInitialMessage(false);
    ReportService.getEmployeeSalesSummary(reqObj)
      .then((res) => {
        //console.log(JSON.stringify(res))
        if (res?.data) {
          setEmployeeSalesReportList(res?.data);
          setIsLoader(false);
        } else {
          setEmployeeSalesReportList();
          setIsLoader(false);
        }
      })
      .catch((err) => console.log(err));
  };

  const columns = [
    {
      id: "staffName",
      Header: "Staff Name",
      accessor: (tc) => tc.staffName,
    },
    {
      id: "totalProducts",
      Header: "Total Products",
      accessor: (pp) => { return Utilities.toDollar(pp.totalProducts) },
      meta: { sum: true, currency: true, numeric: true },
      Footer: info => {
        const total = React.useMemo(
          () =>
            info.rows.reduce((sum, row) => row.original.totalProducts + sum, 0),
          [info.rows]
        )
        return <>{Utilities.toDollar(total)}</>
      },
    },
    {
      id: "retailPercentage",
      Header: "Retail %",
      accessor: (pp) => pp.retailPercentage,
    },
    {
      id: "totalServices",
      Header: "Total Services",
      accessor: (pp) => { return Utilities.toDollar(pp.totalServices) },
      meta: { sum: true, currency: true, numeric: true },
      Footer: info => {
        const total = React.useMemo(
          () =>
            info.rows.reduce((sum, row) => row.original.totalServices + sum, 0),
          [info.rows]
        )
        return <>{Utilities.toDollar(total)}</>
      },
    },
    {
      id: "totalSales",
      Header: "Total Sales",
      accessor: (pp) => { return Utilities.toDollar(pp.totalSales) },
      meta: { sum: true, currency: true, numeric: true },
      Footer: info => {
        const total = React.useMemo(
          () =>
            info.rows.reduce((sum, row) => row.original.totalSales + sum, 0),
          [info.rows]
        )
        return <>{Utilities.toDollar(total)}</>
      },
    },
    {
      id: "clientCount",
      Header: "Client Count",
      meta: { numeric: true },
      accessor: (pp) => { return pp.clientCount },
    },
    {
      id: "averageRetailPricePerClient",
      Header: "Avg. Retail Price/Client",
      accessor: (pp) => { return Utilities.toDollar(pp.averageRetailPricePerClient) },
      meta: { numeric: true },
      Footer: info => {
        const total = React.useMemo(
          () =>
            info.rows.reduce((sum, row) => row.original.averageRetailPricePerClient + sum, 0),
          [info.rows]
        )
        return <>{Utilities.toDollar(total)}</>
      },
    },
    {
      id: "tips",
      Header: "Tips",
      accessor: (pp) => { return Utilities.toDollar(pp.tips) },
      meta: { numeric: true },
      // Footer: info => {
      //   const total = React.useMemo(
      //     () =>
      //       info.rows.reduce((sum, row) => row.original.tips + sum, 0),
      //     [info.rows]
      //   )
      //   return <>{Utilities.toDollar(total)}</>
      // },
    },
  ]

  return (
    <>
      {isLoader &&
        <DimLoader loadMessage="Processing" />
      }
      <div className="row d-flex g-3">
        <div className="col-12 m-p-0">
          <Module title="Filters">
            <div className='row d-flex'>
              <div className='col-12 mx-0  report-filters'>
                <div className="d-flex row justify-content-center align-items-end">
                  <DatePicker locationClearable={isLocationClearable} setLocationId={setLocationId} startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} includeAll />
                  <div className='col-md col-12'>
                    <div className='ui field'>
                      <label>Provider</label>
                      <HPTSelect
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={providerList}
                        name="doctorId"
                        isDisabled={!providerList}
                        isClearable={true}
                        isSearchable
                        value={providerList && doctorId ? providerList.find(obj => obj.id === doctorId) : null}
                        onChange={e => {
                          if (e?.id) {
                            setDoctorId(e.id)
                          }
                          else {
                            setDoctorId()
                          }
                        }}
                        loadingMessage="Providers are loading..."
                        getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                        getOptionValue={(option) => option.id}
                      />
                    </div>
                  </div>
                  <div className="col-md-auto col-12"><button className="btn btn-primary" onClick={e => { e.preventDefault(); setEmployeeSalesReportList(); getEmployeeSalesReportLookup() }} title="Pull Report"><i className="icon arrow circle right" /></button></div>
                </div>
              </div>
            </div>
          </Module>
        </div>
        <div className="col-12 m-p-0">
          <Module title="Employee Sales Report">
            <Table2
              export
              searchable
              title="Employee Sales Report"
              data={employeeSalesReportList}
              loading={isLoader}
              columns={columns}
              initialMessage={initialMessage}
            />
          </Module>
        </div>
      </div>
    </>
  );
};

export default EmployeeSalesReport;
